<template>
  <div class="ct">
    <div class="ct__avatar">
      <img v-if="isProta" :src="protaAvatar" class="ct__avatar-img" alt="Prota" />
      <img v-else-if="isProka" :src="prokaAvatar" class="ct__avatar-img" alt="Proka" />
      <cortex-icon v-else :size="16"></cortex-icon>
    </div>
    <div v-if="usingTools" class="ct__tools-hint">
      <i class="fas fa-wrench"></i>
      <span>{{ $t('kortex.usingTools') }}</span>
      <span class="ct__tools-pulse"></span>
    </div>
    <div v-else class="ct__dots">
      <span></span>
      <span></span>
      <span></span>
    </div>
  </div>
</template>

<script>
var protaAvatar = require('@/assets/images/prota-avatar.png')
var prokaAvatar = require('@/assets/images/proka-avatar.png')

export default {
  name: 'TypingIndicator',
  props: {
    usingTools: {
      type: Boolean,
      default: false
    }
  },
  data: function () {
    return {
      protaAvatar: protaAvatar,
      prokaAvatar: prokaAvatar
    }
  },
  computed: {
    isProta: function () {
      return this.$store.state.cortex.selectedAgentUUID === 'prota'
    },
    isProka: function () {
      return this.$store.state.cortex.selectedAgentUUID === 'proka'
    }
  }
}
</script>

<style scoped lang="scss">
.ct {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 20px;
}

.ct__avatar {
  width: 30px;
  height: 30px;
  border-radius: 9px;
  background: rgba(108, 128, 255, 0.12);
  border: 1px solid rgba(108, 128, 255, 0.22);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  box-shadow: 0 0 10px rgba(108, 128, 255, 0.15);

  i {
    font-size: 14px;
    background: linear-gradient(135deg, #6c80ff, #a078d0);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
  }
}

.ct__avatar-img {
  width: 100%;
  height: 100%;
  border-radius: 50%;
  object-fit: cover;
}

.ct__dots {
  display: flex;
  align-items: center;
  gap: 5px;
  background: rgba(255, 255, 255, 0.04);
  border: 1px solid rgba(255, 255, 255, 0.07);
  border-top-color: rgba(255, 255, 255, 0.11);
  border-radius: 4px 18px 18px 18px;
  padding: 12px 16px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);

  span {
    display: block;
    width: 7px;
    height: 7px;
    border-radius: 50%;
    background: rgba(108, 128, 255, 0.55);
    animation: ct-bounce 1.3s infinite;

    &:nth-child(1) { animation-delay: 0s; }
    &:nth-child(2) { animation-delay: 0.18s; }
    &:nth-child(3) { animation-delay: 0.36s; }
  }
}

@keyframes ct-bounce {
  0%, 75%, 100% { transform: translateY(0); opacity: 0.4; }
  38%           { transform: translateY(-5px); opacity: 1; }
}

.ct__tools-hint {
  display: flex;
  align-items: center;
  gap: 8px;
  background: rgba(255, 255, 255, 0.04);
  border: 1px solid rgba(255, 255, 255, 0.07);
  border-top-color: rgba(255, 255, 255, 0.11);
  border-radius: 4px 18px 18px 18px;
  padding: 10px 16px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);
  font-size: 13px;
  color: rgba(255, 255, 255, 0.5);

  i {
    font-size: 11px;
    color: rgba(108, 128, 255, 0.7);
  }
}

.ct__tools-pulse {
  display: inline-block;
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: rgba(108, 128, 255, 0.6);
  animation: ct-pulse 1.2s ease-in-out infinite;
}

@keyframes ct-pulse {
  0%, 100% { opacity: 0.3; transform: scale(0.8); }
  50%       { opacity: 1; transform: scale(1.2); }
}
</style>
